import React from 'react';
import { TruckIcon, BanknoteIcon, UserIcon, UserPlusIcon } from '../icons';

interface FilterChipsProps {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
  counts: {
    all: number;
    to_deliver: number;
    unpaid: number;
    new: number;
  };
}

export const FilterChips: React.FC<FilterChipsProps> = ({ activeFilter, onFilterChange, counts }) => {
  const filters = [
    { id: 'all', label: 'Tous', icon: UserIcon, color: 'blue' },
    { id: 'to_deliver', label: 'À livrer', icon: TruckIcon, color: 'amber' },
    { id: 'unpaid', label: 'Impayés', icon: BanknoteIcon, color: 'red' },
    { id: 'new', label: 'Nouveaux', icon: UserPlusIcon, color: 'indigo' },
  ];

  return (
    <div className="flex overflow-x-auto pb-4 pt-2 px-4 no-scrollbar gap-2.5 -mx-4 scroll-smooth">
      {filters.map((f) => {
        const isActive = activeFilter === f.id;
        const Icon = f.icon;
        
        const colorClasses: Record<string, string> = {
          blue: isActive ? 'bg-blue-600 border-blue-600 shadow-blue-500/20' : 'text-blue-600 bg-blue-500/10 dark:bg-blue-400/10 border-blue-200/50 dark:border-blue-400/20',
          amber: isActive ? 'bg-amber-500 border-amber-500 shadow-amber-500/20' : 'text-amber-600 bg-amber-500/10 dark:bg-amber-400/10 border-amber-200/50 dark:border-amber-400/20',
          red: isActive ? 'bg-red-500 border-red-500 shadow-red-500/20' : 'text-red-600 bg-red-500/10 dark:bg-red-400/10 border-red-200/50 dark:border-red-400/20',
          indigo: isActive ? 'bg-indigo-500 border-indigo-500 shadow-indigo-500/20' : 'text-indigo-600 bg-indigo-500/10 dark:bg-indigo-400/10 border-indigo-200/50 dark:border-indigo-400/20',
        };

        return (
          <button
            key={f.id}
            onClick={() => onFilterChange(f.id)}
            className={`flex items-center gap-2 px-4 py-2 rounded-xl whitespace-nowrap transition-all duration-300 border ${
              isActive 
                ? `${colorClasses[f.color]} text-white shadow-md scale-105 font-bold`
                : `${colorClasses[f.color]} hover:scale-105 active:scale-95 font-medium`
            }`}
          >
            <Icon className={`w-4 h-4 ${isActive ? 'text-white' : ''}`} />
            <span className="text-sm font-semibold">{f.label}</span>
            {counts[f.id as keyof typeof counts] > 0 && (
              <span className={`text-[10px] px-1.5 py-0.5 rounded-lg font-bold min-w-[1.2rem] text-center ${
                isActive ? 'bg-white/20 text-white' : `bg-black/5 dark:bg-white/10`
              }`}>
                {counts[f.id as keyof typeof counts]}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};
